/* eslint-disable consistent-return */
import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const RaceResultData = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  }),
);

export const ContentWrapper = styled.div(() =>
  mq({
    fontSize: defaultTheme.font.size.xs,
  }),
);

export const InfoText = styled.p(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    lineHeight: defaultTheme.font.height.s,
    '& > span': {
      marginRight: defaultTheme.spacing.xs,
    },
  }),
);
